import { User } from '@sr/types';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Link as TUILink } from 'theme-ui';
import { Button, DownloadIcon, Link, LockIcon } from '../../ui';
import API from '../../utils/api';
import { downloadResume } from '../../utils/download-resume';
import isPro from '../../utils/is-pro';

export default function DownloadButton({
  resumeId,
  user,
}: {
  resumeId: string;
  user: User | null | false;
}) {
  const history = useHistory();
  const [isDownloading, setIsDownloading] = useState(false);
  const shouldCreateAccount = user && user.isAnonymous;

  if (!user) return null;

  function handleClick(e: React.SyntheticEvent<HTMLButtonElement>) {
    e.preventDefault();
    if (!isPro(user)) {
      history.push('/upgrade?refLink=headerDownload');
    } else {
      setIsDownloading(true);
      downloadResume(resumeId).then(() => {
        setIsDownloading(false);
      });
    }
    if (user) {
      API.events.logEvent({
        userId: user.id,
        eventName: 'Resume PDF Downloaded',
        properties: {
          Blocked: isPro(user) ? 'False' : 'True',
          Location: 'Header',
        },
      });
    }
  }

  if (isPro(user)) {
    return (
      <Button
        onClick={handleClick}
        sx={{
          display: ['none', 'flex'],
          justifyContent: 'center',
          width: 'auto',
          py: '8px',
          pl: '10px',
          mr: 3,
          fontWeight: 500,
        }}
        data-testid="download-pdf"
        id="gi-download-pdf"
      >
        <DownloadIcon color="white" size={24} mr={2} />
        {isDownloading ? 'Downloading...' : 'Download'}
      </Button>
    );
  }

  // Send anonymous users to account creation before upsell page
  if (shouldCreateAccount) {
    return (
      <TUILink
        href="/v2/setup/account?fromapp=true"
        variant="secondaryButton"
        data-testid="upgrade-to-download"
        sx={{
          display: ['none', 'flex'],
          justifyContent: 'center',
          width: 'auto',
          py: '8px',
          pl: '10px',
          mr: 3,
          fontWeight: 500,
        }}
      >
        <LockIcon color="black" size={24} mr={2} />
        Upgrade to Download
      </TUILink>
    );
  }

  return (
    <Link
      to="/upgrade"
      onClick={handleClick}
      variant={shouldCreateAccount ? 'secondaryButton' : 'primaryButton'}
      data-testid="upgrade-to-download"
      sx={{
        display: ['none', 'flex'],
        justifyContent: 'center',
        width: 'auto',
        py: '8px',
        pl: '10px',
        mr: 3,
        fontWeight: 500,
      }}
    >
      <LockIcon
        color={shouldCreateAccount ? 'black' : 'white'}
        size={24}
        mr={2}
      />
      Upgrade to Download
    </Link>
  );
}
